export default __webpack_public_path__ + "static/media/left-top.20062b5d.gif";